<template>
  <div>
    <base-header class="pb-6 bg-light">
      <b-row aling-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">Support</h6>
        </b-col>
        <b-col cols="5" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>

    </base-header>

    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-form @submit.prevent="submitToSupport">
          <div  class=" text-center m-md-6 m-3 mt-6">
            <span class="h3 font-weight-100">
              Thank you for your interest in DCC. <br>
              Please feel free to contact us via phone or email, or fill out this form to submit your inquiry. <br>
              We look forward to hearing from you!
            </span>
            <hr>
          </div>
          <b-row class="ml-3">
            <b-col lg="12">
              <span class="h3">We’re always ready to work with you</span>
              <br>
              <p class="mt-3">
                <b-icon icon="telephone-plus"  variant="info" class="mr-3"></b-icon>  P: (920) 351-4054
              </p>
              <p class="mt-3">
                <i class="fas fa-fax mr-3 text-danger" aria-hidden="true"></i>   F: (920) 351-4626
              </p>
              <p class="mt-3">
                <b-icon icon="envelope"  variant="indigo" class="mr-3"></b-icon>  {{supportForm.toSupport}}
              </p>
            </b-col>
          </b-row>
          <div class="m-4">
            <b-row>
              <b-col md="12">
                <base-input
                  type="text"
                  label="Username"
                  placeholder="Username"
                  v-model="supportForm.name"
                >
                </base-input>
              </b-col>
              <b-col lg="12">
                <base-input
                  type="text"
                  label="User Email"
                  placeholder="User Email"
                  v-model="supportForm.email"
                >
                </base-input>
              </b-col>
              <b-col lg="12">
                <base-input
                  type="text"
                  label="Phone Number"
                  placeholder="Phone Number"
                  v-model="supportForm.phone"
                >
                </base-input>
              </b-col>
              <b-col lg="12">
                <b-form-textarea
                  label="Content"
                  placeholder="Content ...."
                  rows="3"
                  max-rows="6"
                  v-model="supportForm.content"
                >
                </b-form-textarea>
              </b-col>
              <b-col xl="12 text-right mt-3">
                <base-button type="info" title="Submit"  >
                      Submit
                  </base-button>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>

<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import configDirective from "../../../common/directive/config-directive";
    export default {
        name: "Support",
      components: {
        RouteBreadCrumb,
      },
      data() {
        return {
          supportForm: {
            toSupport: 'Support@dccllc.net',
            name: '',
            email: '',
            phone: '',
            content: ''
          }
        }
      },
      mounted() {
        document.title = 'Support';
        this.getCustomerUserFunc();
      },
      methods: {
        getCustomerUserFunc() {
          let customerUser = configDirective.getCurrentUser();
          this.supportForm.name = customerUser.name;
          this.supportForm.email = customerUser.email;
          this.supportForm.phone = customerUser.phone_number;
        },

          submitToSupport() {

          }
      }
    }
</script>
